// extracted by mini-css-extract-plugin
export default {"side-bar":"side-bar--13iCP"};